import { useState, useEffect, useRef } from "react";

export const useSocketData = () => {
  const [data, setData] = useState({
    temperature: 22,
    humidity: 55,
    co2: 400,
    energy: 3.5,
    alerts: [
        { id: 1752837939611, type: "Info", message: "High temperature detected", datetime: "7/16/2025, 4:55:39 PM", device_id: 2, device_name: "Soil Sensor" },
        { id: 1752837958367, type: "Info", message: "Sensor offline", datetime: "7/16/2025, 4:55:58 PM", device_id: 3, device_name: "Building Monitor" },
        { id: 1752837966606, type: "Warning", message: "High temperature detected", datetime: "7/16/2025, 4:56:06 PM", device_id: 2, device_name: "Soil Sensor" },
        { id: 1752837975601, type: "Critical", message: "High temperature detected", datetime: "7/16/2025, 4:56:15 PM", device_id: 2, device_name: "Soil Sensor" },
        { id: 1752837994364, type: "Critical", message: "Sensor offline", datetime: "7/16/2025, 4:56:34 PM", device_id: 3, device_name: "Building Monitor" },
        { id: 1752838015373, type: "Info", message: "CO2 level elevated", datetime: "7/16/2025, 4:56:55 PM", device_id: 1, device_name: "Industrial Controller" },
        { id: 1752838018367, type: "Warning", message: "Sensor offline", datetime: "7/16/2025, 4:56:58 PM", device_id: 4, device_name: "Freezer Unit" },
        { id: 1752838036348, type: "Info", message: "CO2 level elevated", datetime: "7/16/2025, 4:57:16 PM", device_id: 1, device_name: "Industrial Controller" },
        { id: 1752838038603, type: "Warning", message: "High temperature detected", datetime: "7/16/2025, 4:57:16 PM", device_id: 4, device_name: "Freezer Unit" },
        { id: 1752838048368, type: "Info", message: "Sensor offline", datetime: "7/17/2025, 4:57:28 PM", device_id: 4, device_name: "Freezer Unit" },
        { id: 1752838075378, type: "Critical", message: "Sensor offline", datetime: "7/17/2025, 4:57:55 PM", device_id: 3, device_name: "Building Monitor" },
        { id: 1752838078367, type: "Warning", message: "CO2 level elevated", datetime: "7/17/2025, 4:57:58 PM", device_id: 3, device_name: "Building Monitor" },
        { id: 1752838084374, type: "Info", message: "High temperature detected", datetime: "7/17/2025, 4:58:04 PM", device_id: 1, device_name: "Industrial Controller" },
        { id: 1752838096379, type: "Critical", message: "Sensor offline", datetime: "7/17/2025, 4:58:16 PM", device_id: 3, device_name: "Building Monitor" },
        { id: 1752838099365, type: "Warning", message: "High temperature detected", datetime: "7/17/2025, 4:58:19 PM", device_id: 1, device_name: "Industrial Controller" },
        { id: 1752838146603, type: "Critical", message: "High temperature detected", datetime: "7/17/2025, 4:59:06 PM", device_id: 4, device_name: "Freezer Unit" },
        { id: 1752838156375, type: "Info", message: "CO2 level elevated", datetime: "7/18/2025, 4:59:16 PM", device_id: 2, device_name: "Soil Sensor" },
        { id: 1752838159376, type: "Critical", message: "Sensor offline", datetime: "7/18/2025, 4:59:19 PM", device_id: 1, device_name: "Industrial Controller" },
        { id: 1752838177370, type: "Critical", message: "CO2 level elevated", datetime: "7/18/2025, 4:59:37 PM", device_id: 2, device_name: "Soil Sensor" },
        { id: 1752838199370, type: "Warning", message: "High humidity detected", datetime: "7/18/2025, 4:59:55 PM", device_id: 2, device_name: "Soil Sensor" }

    ],
    devices: [
        {
          id: 1,
          name: "Industrial Controller",
          type: "Industrial Automation",
          status: "Online",
          lat: 28.6139,
          lng: 77.2090,
          location: 'Delhi',
          lastUpdated: new Date().toLocaleString(),
          currentPressure: null,
          currentTemp: null,
          monthlyAvailability: null,
          monthlyProduction: null,
          brokenEvents: [],
        },
        {
          id: 2,
          name: "Soil Sensor",
          type: "Smart Agriculture",
          status: "Online",
          lat: 19.0760,
          lng: 72.8777,
          location: 'Mumbai',
          lastUpdated: new Date().toLocaleString(),
          waterLevel: null,
          soilMoisture: null,
          humidity: null,
          temperature: null,
          irrigationSystem: null,
          sprinklerStatus: null,
        },
        {
          id: 3,
          name: "Building Monitor",
          type: "Building Monitoring",
          status: "Offline",
          lat: 13.0827,
          lng: 80.2707,
          location: 'Chennai',
          lastUpdated: new Date().toLocaleString(),
          entranceDoor: null,
          backDoor: null,
          alarmStatus: null,
          livingRoomTemp: null,
          livingRoomHumidity: null,
          co2Level: null,
          energyConsumed: null,
          waterConsumed: null,
          lights: { office: null, livingRoom: null, bedroom: null },
          cameras: { entrance: null, corridor: null },
          leakStatus: { sink: null, bathroom: null, dishwasher: null },
        },
        {
          id: 4,
          name: "Freezer Unit",
          type: "Freezer Status",
          status: "Online",
          lat: 12.9716,
          lng: 77.5946,
          location: 'Bangalore',
          lastUpdated: new Date().toLocaleString(),
          freezerTemperature: null,
          compressorStatus: null,
          doorStatus: null,
          temperatureHistory: [],
          historicalData: [],
        },
        {
            id: 5,
            name: "Temp-Humidity Sensor",
            type: "Temperature & Humidity",
            status: "Online",
            lat: 22.5726, // Kolkata
            lng: 88.3639,
            location:'Kolkata',
            lastUpdated: new Date().toLocaleString(),
        },
        {
          id: 6,
          name: "Energy Meter",
          type: "Energy Metering",
          status: "Online",
          lat: 23.0225, // Ahmedabad
          lng: 72.5714,
          location: 'Ahmedabad',
          lastUpdated: new Date().toLocaleString(),

          // ✅ Energy Metering fields with empty or null values
          current: null,          // Amps
          load: null,             // %
          voltage: null,          // Volts
          relayStatus: null,      // ON/OFF
          rssi: null,             // Wi-Fi signal

          // ✅ History arrays initialized empty
          energyHistory: [],      // For energy spent graph
          powerHistory: [],       // For power consumed graph

          // ✅ Logs table initialized empty
          logs: []
        },
        {
          id: 7,
          name: "Water Flow Meter",
          type: "Water Metering",
          status: "Online",
          lat: 17.3850, // Hyderabad
          lng: 78.4867,
          location: 'Hyderabad',
          lastUpdated: new Date().toLocaleString(),

          // ✅ Water Metering Metrics (initialized as empty/null)
          consumedDay: null,        // in m³
          consumedWeek: null,       // in m³
          consumedAllTime: null,    // in m³
          flowRate: null,           // in m³/hr
          velocity: null,           // in m/s
          batteryLevel: null,       // in %
          
          // ✅ Historical data for charts
          dailyConsumption: [],     // Array of { time, value }
          flowHistory: [],          // Array of { time, value }
          velocityHistory: [],      // Array of { time, value }
        },
        {
          id: 8,
          name: "Vehicle Tracker",
          type: "Vehicle Tracking",
          status: "Online",
          lat: 18.5204, // Pune
          lng: 73.8567,
          location: 'Pune',
          lastUpdated: new Date().toLocaleString(),
          fuelLevel: null,
          busSpeed: null,
          tripOdometer: null,
          internalTemp: null,
          acStatus: null,
          speedHistory: [],
          route: [],
        },
        {
          id: 9,
          name: "Smart Home Hub",
          type: "Smart Home Dashboard",
          status: "Online",
          lat: 15.2993, // Goa
          lng: 74.1240,
          location: 'Goa',
          lastUpdated: new Date().toLocaleString(),

          // Weather Information
          weather: {
            temperature: null,
            condition: "",
            high: null,
            low: null,
          },
          airQuality:{
            aqi: null,
            status: ''
          },
          hub:{
            connected: null,
            rssi: null
          },
          // Climate Control
          climate: {
            currentTemp: null,
            mode: "",
          },

          // Lighting
          lighting: {
            bedroomLight: "",
            brightness: 0,
          },

          // Security
          security: {
            doorLocked: "",
          },

          // Energy Monitoring Data (Graph)
          energyMonitor: [], // Will hold objects like { month: 'Apr', electricity: 0, gas: 0, water: 0 }

          // Recent Activity Logs
          recentActivity: [], // Will hold objects like { time: '12:30 PM', message: 'Lights turned ON' }

          // Floor Plan Devices
          floorPlanDevices: [
            // Example: { id: "light1", icon: "lightbulb", position: { top: "30%", left: "40%" } }
          ],
        }
    ]
  });

  const prevAlertCount = useRef(0);

  // ✅ Push Notification Function
  const sendPushNotification = async (alert) => {
    const pushEnabled = localStorage.getItem("pushEnabled") === "true";
    if (!pushEnabled) return;

    if ("Notification" in window && Notification.permission === "granted" && "serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.ready;
      registration.showNotification(alert.type, {
        body: alert.message,
        icon: "/logo192.png",
        tag: `alert-${alert.id}`,
      });
    }
  };

useEffect(() => {
  const updateData = () => {
    setData((prev) => {
      const updatedDevices = prev.devices.map((device) => {
        let newStatus = "Online";
        // let newStatus = device.status;
        // if (Math.random() > 0.8) {
        //   newStatus = device.status === "Online" ? "Offline" : "Online";
        // }

        // ✅ Industrial Automation Metrics
        if (device.type === "Industrial Automation") {
          return {
            ...device,
            status: newStatus,
            lastUpdated: new Date().toLocaleString(),
            currentPressure: newStatus === "Online" ? (Math.random() * 10).toFixed(1) : null,
            currentTemp: newStatus === "Online" ? (30 + Math.random() * 40).toFixed(1) : null,
            monthlyAvailability: {
              working: Math.floor(200 + Math.random() * 300),
              idle: Math.floor(50 + Math.random() * 100),
              stopped: Math.floor(50 + Math.random() * 100),
            },
            monthlyProduction: {
              july: Math.floor(500 + Math.random() * 200),
              august: Math.floor(500 + Math.random() * 200),
              september: Math.floor(500 + Math.random() * 200),
              october: Math.floor(500 + Math.random() * 200),
              november: Math.floor(500 + Math.random() * 200),
            },
            brokenEvents: [
              { event: "Machine does not turn on", month: "September", datetime: new Date().toLocaleString() },
              { event: "Pressure issue detected", month: "September", datetime: new Date().toLocaleString() },
              { event: "Temperature is too high", month: "September", datetime: new Date().toLocaleString() },
            ],
          };
        }

        // ✅ Smart Agriculture Metrics
        if (device.type === "Smart Agriculture") {
          return {
            ...device,
            status: newStatus,
            lastUpdated: new Date().toLocaleString(),
            waterLevel: newStatus === "Online" ? (Math.random() * 100).toFixed(0) : null,
            soilMoisture: newStatus === "Online" ? (20 + Math.random() * 50).toFixed(1) : null,
            humidity: newStatus === "Online" ? (50 + Math.random() * 20).toFixed(1) : null,
            temperature: newStatus === "Online" ? (15 + Math.random() * 25).toFixed(1) : null,
            irrigationSystem: Math.random() > 0.5 ? "On" : "Off",
            sprinklerStatus: Math.random() > 0.5 ? "On" : "Off",
          };
        }

        // ✅ Building Monitoring Metrics
        if (device.type === "Building Monitoring") {
          return {
            ...device,
            status: newStatus,
            lastUpdated: new Date().toLocaleString(),
            entranceDoor: Math.random() > 0.2 ? "Closed" : "Open",
            backDoor: Math.random() > 0.2 ? "Closed" : "Open",
            alarmStatus: Math.random() > 0.7 ? "Armed" : "Disarmed",
            livingRoomTemp: newStatus === "Online" ? (18 + Math.random() * 10).toFixed(1) : null,
            livingRoomHumidity: newStatus === "Online" ? (30 + Math.random() * 20).toFixed(1) : null,
            co2Level: newStatus === "Online" ? (400 + Math.random() * 200).toFixed(0) : null,
            energyConsumed: (100 + Math.random() * 100).toFixed(0),
            waterConsumed: (50 + Math.random() * 100).toFixed(0),
            lights: {
              office: Math.random() > 0.5 ? "ON" : "OFF",
              livingRoom: Math.random() > 0.5 ? "ON" : "OFF",
              bedroom: Math.random() > 0.5 ? "ON" : "OFF",
            },
            cameras: {
              entrance: Math.random() > 0.5 ? "ON" : "OFF",
              corridor: Math.random() > 0.5 ? "ON" : "OFF",
            },
            leakStatus: {
              sink: Math.random() > 0.8 ? "Leaking" : "Dry",
              bathroom: Math.random() > 0.8 ? "Leaking" : "Dry",
              dishwasher: Math.random() > 0.8 ? "Leaking" : "Dry",
            },
          };
        }

        // ✅ Freezer Status Metrics
        if (device.type === "Freezer Status") {
          return {
            ...device,
            status: newStatus,
            lastUpdated: new Date().toLocaleString(),
            freezerTemperature: newStatus === "Online" ? (0 + Math.random() * 10).toFixed(1) : null,
            compressorStatus: newStatus === "Online" ? (Math.random() > 0.5 ? "on" : "off") : "off",
            doorStatus: newStatus === "Online" ? (Math.random() > 0.7 ? "open" : "closed") : "closed",
            temperatureHistory: Array.from({ length: 12 }, () => ({
              time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }),
              temp: (0 + Math.random() * 10).toFixed(1),
            })),
            historicalData: [
              { compressor: "off", door: "closed", temperature: "6 °F", datetime: new Date().toLocaleString() },
              { compressor: "on", door: "open", temperature: "8 °F", datetime: new Date().toLocaleString() },
              { compressor: "on", door: "closed", temperature: "5 °F", datetime: new Date().toLocaleString() },
            ],
          };
        }

        // ✅ Energy Metering Metrics
        if (device.type === "Energy Metering") {
          return {
            ...device,
            status: newStatus,
            lastUpdated: new Date().toLocaleString(),
            current: newStatus === "Online" ? (0.2 + Math.random() * 1.5).toFixed(2) : null, // Amps
            load: newStatus === "Online" ? Math.floor(10 + Math.random() * 90) : null, // %
            voltage: newStatus === "Online" ? (110 + Math.random() * 40).toFixed(1) : null, // Volts
            relayStatus: newStatus === "Online" ? (Math.random() > 0.5 ? "ON" : "OFF") : "OFF",
            rssi: Math.random() > 0.5 ? "Good" : "Weak", // Wi-Fi signal
            energyHistory: Array.from({ length: 10 }, () => ({
              time: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
              }),
              energy: (10 + Math.random() * 50).toFixed(1) // Energy in kWh
            })),
            powerHistory: Array.from({ length: 10 }, () => ({
              time: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
              }),
              power: (50 + Math.random() * 100).toFixed(1) // Power in W
            })),
            logs: [
              {
                load: Math.floor(10 + Math.random() * 90) + "%",
                voltage: `${(110 + Math.random() * 40).toFixed(1)} V`,
                current: `${(0.2 + Math.random() * 1.5).toFixed(2)} A`,
                datetime: new Date().toLocaleString()
              },
              {
                load: Math.floor(10 + Math.random() * 90) + "%",
                voltage: `${(110 + Math.random() * 40).toFixed(1)} V`,
                current: `${(0.2 + Math.random() * 1.5).toFixed(2)} A`,
                datetime: new Date().toLocaleString()
              },
              {
                load: Math.floor(10 + Math.random() * 90) + "%",
                voltage: `${(110 + Math.random() * 40).toFixed(1)} V`,
                current: `${(0.2 + Math.random() * 1.5).toFixed(2)} A`,
                datetime: new Date().toLocaleString()
              }
            ]
          };
        }

        // ✅ Water Metering Metrics
      if (device.type === "Water Metering") {
        return {
          ...device,
          status: newStatus,
          lastUpdated: new Date().toLocaleString(),

          // ✅ Realistic values for Water Metering
          consumedDay: newStatus === "Online" ? (20000 + Math.random() * 5000).toFixed(2) : null, // m³
          consumedWeek: newStatus === "Online" ? (450000 + Math.random() * 50000).toFixed(2) : null, // m³
          consumedAllTime: newStatus === "Online" ? (600000 + Math.random() * 100000).toFixed(2) : null, // m³
          flow: newStatus === "Online" ? (1 + Math.random() * 4).toFixed(1) : null, // m³/hr
          velocity: newStatus === "Online" ? (0.1 + Math.random() * 1).toFixed(2) : null, // m/s
          batteryLevel: newStatus === "Online" ? (50 + Math.random() * 50).toFixed(0) : null, // %

          // ✅ History data for charts
          dailyConsumption: Array.from({ length: 10 }, () =>
            (20000 + Math.random() * 5000).toFixed(0)
          ),
          flowHistory: Array.from({ length: 12 }, () => ({
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }),
            value: (1 + Math.random() * 4).toFixed(1)
          })),
          velocityHistory: Array.from({ length: 12 }, () => ({
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }),
            value: (0.1 + Math.random() * 1).toFixed(2)
          })),
        };
      }

      // ✅ Vehicle Tracking Metrics
      if (device.type === "Vehicle Tracking") {
        return {
          ...device,
          status: newStatus,
          lastUpdated: new Date().toLocaleString(),
          fuelLevel: newStatus === "Online" ? (10 + Math.random() * 90).toFixed(1) : null, // % fuel
          busSpeed: newStatus === "Online" ? (5 + Math.random() * 45).toFixed(2) : null, // MPH
          tripOdometer: newStatus === "Online" ? (0.1 + Math.random() * 10).toFixed(2) : null, // miles
          internalTemp: newStatus === "Online" ? (60 + Math.random() * 20).toFixed(1) : null, // °F
          acStatus: Math.random() > 0.5 ? "ON" : "OFF",
          speedHistory: Array.from({ length: 15 }, () => ({
            time: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            }),
            speed: (Math.random() * 50).toFixed(1),
          })),
          route: [
            { lat: 41.886912, lng: -87.631934 },
            { lat: 41.888000, lng: -87.629000 },
            { lat: 41.889500, lng: -87.626500 },
            { lat: 41.891000, lng: -87.623000 },
          ],
        };
      }

      // ✅ Smart Home Dashboard Metrics
    if (device.type === "Smart Home Dashboard") {
      return {
        ...device,
        status: newStatus,
        lastUpdated: new Date().toLocaleString(),

        // Weather & Air Quality
        weather: (() => {
      const conditions = [
        { condition: "Sunny", icon: "☀️" },
        { condition: "Cloudy", icon: "☁️" },
        { condition: "Rainy", icon: "🌧️" },
      ];
      const selected = conditions[Math.floor(Math.random() * conditions.length)];

      return {
        temperature: (60 + Math.random() * 20).toFixed(0), // °F
        condition: selected.condition,
        icon: selected.icon, // Matches condition
        high: (70 + Math.random() * 10).toFixed(0),
        low: (50 + Math.random() * 10).toFixed(0),
      };
    })(),
    airQuality: (() => {
      const aqi = (50 + Math.random() * 100).toFixed(0);
      let status = "";
      let emoji = "";

      if (aqi <= 75) {
        status = "Low";
        emoji = "😊";
      } else if (aqi <= 120) {
        status = "Moderate";
        emoji = "😶‍🌫️";
      } else {
        status = "High";
        emoji = "😷";
      }

      return {
        aqi: aqi,
        status: status,
        icon: emoji,
      };
    })(),
    // Hub with RSSI
    hub: {
      connected: true,
      rssi: (-40 - Math.random() * 20).toFixed(0), // RSSI in dBm
    },

    // Rooms Summary
    rooms: [
      { name: "Living Room", lights: "ON", climate: "72°F", security: "Locked" },
      { name: "Bedroom", lights: "OFF", climate: "70°F", security: "Unlocked" },
      { name: "Office", lights: "ON", climate: "74°F", security: "Locked" },
      { name: "Family Room", lights: "ON", climate: "73°F", security: "Locked" },
    ],

    // Energy Monitor (with units)
    energyMonitor: Array.from({ length: 6 }, (_, i) => ({
      month: ["Apr", "May", "Jun", "Jul", "Aug", "Sep"][i],
      electricity: Math.floor(100 + Math.random() * 100), // in kWh
      gas: Math.floor(50 + Math.random() * 50),           // in m³
      water: Math.floor(30 + Math.random() * 30),         // in L
    })),

    // Recent Activity
    recentActivity: [
      {
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        message: "Activated home wake-up mode.",
      },
      {
        time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        message: "Living Room lights turned ON.",
      },
    ],

    // Floor Plan Devices (same structure as before)
    floorPlanDevices: [
      {
        room: "Living Room",
        icon: "FaCouch",
        devices: [
          { id: "light_living", type: "light", icon: "lightbulb", position: { top: "78%", left: "80%" }, state: "ON", lastUpdated: "10:15 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Activated home wake-up mode." } ] },
          { id: "switch_living", type: "switch", icon: "toggle-on", position: { top: "78%", left: "85%" }, state: "ON", lastUpdated: "10:15 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Activated home wake-up mode." } ] },
          { id: "cam_living", type: "camera", icon: "video", position: { top: "50%", left: "80%" }, lastUpdated: "10:10 AM", lastSavedPic: "/camera1.png", streamUrl: "https://demo.rtsp.stream/", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Camera stream checked." } ] }
        ]
      },
      {
        room: "Bedroom",
        icon: "FaBed",
        devices: [
          { id: "light_bedroom", type: "light", icon: "lightbulb", position: { top: "20%", left: "10%" }, state: "OFF", lastUpdated: "10:05 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Light turned OFF." } ] },
          { id: "switch_bedroom", type: "switch", icon: "toggle-off", position: { top: "22%", left: "12%" }, state: "OFF", lastUpdated: "10:05 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Switch turned OFF." } ] },
          { id: "cam_bedroom", type: "camera", icon: "video", position: { top: "24%", left: "15%" }, lastUpdated: "10:00 AM", lastSavedPic: "/camera2.png", streamUrl: "https://demo.rtsp.stream/", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Camera stream checked." } ] }
        ]
      },
      {
        room: "Kitchen",
        icon: "FaUtensils",
        devices: [
          { id: "light_kitchen", type: "light", icon: "lightbulb", position: { top: "25%", left: "85%" }, state: "ON", lastUpdated: "10:12 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Light turned ON." } ] },
          { id: "switch_kitchen", type: "switch", icon: "toggle-on", position: { top: "27%", left: "87%" }, state: "ON", lastUpdated: "10:12 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Switch turned ON." } ] }
        ]
      },
      {
        room: "Office",
        icon: "FaBriefcase",
        devices: [
          { id: "light_office", type: "light", icon: "lightbulb", position: { top: "60%", left: "35%" }, state: "OFF", lastUpdated: "09:55 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Light turned OFF." } ] },
          { id: "switch_office", type: "switch", icon: "toggle-off", position: { top: "75%", left: "35%" }, state: "OFF", lastUpdated: "09:55 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Switch turned OFF." } ] }
        ]
      },
      {
        room: "Family Room",
        icon: "FaUsers",
        devices: [
          { id: "light_family1", type: "light", icon: "lightbulb", position: { top: "55%", left: "65%" }, state: "ON", lastUpdated: "10:20 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Light turned ON." } ] },
          { id: "switch_family1", type: "switch", icon: "toggle-on", position: { top: "55%", left: "70%" }, state: "ON", lastUpdated: "10:20 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Switch turned ON." } ] },
          { id: "light_family2", type: "light", icon: "lightbulb", position: { top: "55%", left: "50%" }, state: "ON", lastUpdated: "10:25 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Light turned ON." } ] },
          { id: "switch_family2", type: "switch", icon: "toggle-on", position: { top: "55%", left: "55%" }, state: "ON", lastUpdated: "10:25 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Switch turned ON." } ] }
        ]
      },
      {
        room: "Hall",
        icon: "FaWifi",
        devices: [
          { id: "hub_main", type: "hub", icon: "wifi", position: { top: "48%", left: "45%" }, state: "Connected", lastUpdated: "10:30 AM", recentActivity: [ { time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), message: "Hub connected successfully." } ] }
        ]
      }
    ]
  };
}
        // ✅ Default Device Metrics
        return {
          ...device,
          status: newStatus,
          lastUpdated: new Date().toLocaleString(),
          temperature: newStatus === "Online" ? (20 + Math.random() * 5).toFixed(1) : null,
          humidity: newStatus === "Online" ? (50 + Math.random() * 10).toFixed(1) : null,
          co2: newStatus === "Online" ? (380 + Math.random() * 40).toFixed(0) : null,
          energy: newStatus === "Online" ? (3 + Math.random() * 2).toFixed(1) : null,
        };
      });

      // ✅ Random Alerts
      let newAlerts = prev.alerts;
      if (Math.random() > 0.8) {
        const randomDevice = updatedDevices[Math.floor(Math.random() * updatedDevices.length)];
        newAlerts = [
          ...prev.alerts,
          {
            id: Date.now(),
            type: ["Critical", "Warning", "Info"][Math.floor(Math.random() * 3)],
            message: ["High temperature detected", "CO2 level elevated", "Sensor offline"][Math.floor(Math.random() * 3)],
            datetime: new Date().toLocaleString(),
            device_id: randomDevice.id,
            device_name: randomDevice.name,
          },
        ];
      }

      return { ...prev, devices: updatedDevices, alerts: newAlerts };
    });
  };

  updateData(); // ✅ Execute immediately once
  const interval = setInterval(updateData, 5000); // ✅ Schedule next updates
  return () => clearInterval(interval);
}, []);


  // ✅ Detect new alert and trigger push notification
  useEffect(() => {
    if (data.alerts.length > prevAlertCount.current) {
      const latestAlert = data.alerts[data.alerts.length - 1];
      sendPushNotification(latestAlert);
      prevAlertCount.current = data.alerts.length;
    }
  }, [data.alerts]);

  return data;
};
